import {
  Layout,
  PageSize,
  TemplateFilters,
  TemplateType,
} from 'hooks/usePaginatedTemplatesSearch/usePaginatedTemplatesSearch.types';

/**
 * Toggles the `planType` filter on or off
 * Note: Directly mutates the `filters` object
 *
 * @param filters Filters to modify
 * @param planType planType to toggle
 * @returns modified filters
 */
const togglePlanTypeFilter = (filters: TemplateFilters, planType: TemplateType) => {
  if (!filters?.planType) {
    filters.planType = [];
  }

  const planTypeIdx = filters.planType.indexOf(planType);
  if (planTypeIdx === -1) {
    filters.planType.push(planType);
  } else {
    filters.planType.splice(planTypeIdx, 1);
  }

  return filters;
};

/**
 * Toggles the `pageSize` filter on or off
 * Note: Directly mutates the `filters` object
 *
 * @param filters Filters to modify
 * @param pageSize pageSize to toggle
 * @returns modified filters
 */
const togglePageSizeFilter = (filters: TemplateFilters, pageSize: PageSize) => {
  if (!filters?.pageSize) {
    filters.pageSize = [];
  }

  const pageSizeIdx = filters.pageSize.indexOf(pageSize);
  if (pageSizeIdx === -1) {
    filters.pageSize.push(pageSize);
  } else {
    filters.pageSize.splice(pageSizeIdx, 1);
  }
  return filters;
};

/**
 * Toggles the `layout` filter on or off
 * Note: Directly mutates the `filters` object
 *
 * @param filters Filters to modify
 * @param layout layout to toggle
 * @returns modified filters
 */
const toggleLayoutFilter = (filters: TemplateFilters, layout: Layout) => {
  if (!filters?.layout) {
    filters.layout = [];
  }

  const layoutIdx = filters.layout.indexOf(layout);
  if (layoutIdx === -1) {
    filters.layout.push(layout);
  } else {
    filters.layout.splice(layoutIdx, 1);
  }

  return filters;
};

export { toggleLayoutFilter, togglePageSizeFilter, togglePlanTypeFilter };
